import { __rest, __assign } from '../node_modules/tslib/tslib.es6.esm.js';
import * as React from 'react';
import { SpinnerCircle } from '../assets/icons/SpinnerCircle.esm.js';
import classNames from 'classnames';

var createNvButtonClassNames = function (type, size) {
    return classNames({
        'nv-button': type !== 'plain',
        'nv-button-ghost': type === 'ghost',
        'nv-button-medium': size === 'medium' && type !== 'plain',
        'nv-button-secondary': type === 'secondary',
        'nv-button-secondary-white': type === 'secondaryWhite',
        'nv-button-small': size === 'small' && type !== 'plain',
        'nv-button-white': type === 'white',
        'nv-plain-action': type === 'plain',
    });
};
var NvButton = React.forwardRef(function (_a, ref) {
    var _b, _c;
    var style = _a.style, children = _a.children, _d = _a.variant, variant = _d === void 0 ? 'primary' : _d, className = _a.className, dataTestId = _a.dataTestId, _e = _a.size, size = _e === void 0 ? 'large' : _e, disabled = _a.disabled, _f = _a.element, element = _f === void 0 ? 'button' : _f, onClick = _a.onClick, type = _a.type, href = _a.href, loading = _a.loading, active = _a.active, prefixElement = _a.prefixElement, suffixElement = _a.suffixElement, props = __rest(_a, ["style", "children", "variant", "className", "dataTestId", "size", "disabled", "element", "onClick", "type", "href", "loading", "active", "prefixElement", "suffixElement"]);
    var buttonClassNames = classNames(createNvButtonClassNames(variant, size), {
        'nv-button-active': active,
        'nv-button-loading': loading,
    }, className);
    var Element = element;
    var actionButtons = element === 'button'
        ? {
            onClick: disabled || loading ? undefined : onClick,
            type: disabled || loading ? 'button' : type,
        }
        : {
            href: href,
        };
    /** spinner theme color */
    var spinnerTheme = 'primary';
    if (variant === 'primary')
        spinnerTheme = 'light';
    else if (variant === 'secondaryWhite')
        spinnerTheme = 'secondary-light';
    else if (variant === 'secondary')
        spinnerTheme = 'secondary';
    else if (variant === 'white')
        spinnerTheme = 'dark';
    /** end spinner theme color */
    return (React.createElement(Element, __assign({}, props, { "aria-disabled": disabled, className: buttonClassNames, "data-testid": dataTestId, ref: ref, style: style }, actionButtons),
        React.createElement("div", { className: classNames((_b = {},
                _b['nv-form-prefix'] = !!prefixElement,
                _b)) }, prefixElement),
        children,
        React.createElement("div", { className: classNames((_c = {},
                _c['nv-form-suffix'] = !!suffixElement || loading,
                _c)) }, loading ? (React.createElement(SpinnerCircle, { "data-testid": "".concat(dataTestId, "-spinner"), disabled: disabled, size: size, theme: spinnerTheme })) : (suffixElement))));
});
NvButton.displayName = 'NvButton';

export { createNvButtonClassNames, NvButton as default };
//# sourceMappingURL=NvButton.esm.js.map
